<template>
    <div class="row">
        <div class="col-12">
            <div class="row" :style="rowStyle">
                <div class="form-inline col-md-2">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="grey lighten-1" class="tooltip-small">
                                    mdi-information-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Select the limits if you want to apply additional limits on the dataset.</span>
                    </v-tooltip>

                    <i class="fas fa-sliders-h"></i> <span style="padding-left: 5px;">Limits</span>
                </div>

                <div class="form-group col-md-2 push-down-36">
                    <v-switch
                        v-model="limits_status"
                        inset
                    ></v-switch>
                </div><!--form-group-->
            </div>

            <div class="row" :style="rowStyle" v-if="limits_status">
                <div class="form-inline col-md-2 pt-0">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="grey lighten-1" class="tooltip-small">
                                    mdi-information-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Enter Start and End hour to limit the dataset for specific period of the day.</span>
                    </v-tooltip>
                    <i class="far fa-clock"></i> <span style="padding-left: 5px;"> Time Limit</span>
                </div>
                <div class="form-group col-md-1 pt-6">
                    <v-switch
                        v-model="time_limits_status"
                        inset
                    ></v-switch>
                </div><!--form-group-->
                <div class="form-group col-md-2" v-if="time_limits_status">
                    <v-select
                        label="Start Hour"
                        v-model="time_limits_0"
                        :items="day_hours"
                    ></v-select>
                </div><!--form-group-->
                <div class="form-group col-md-2" v-if="time_limits_status">
                    <v-select
                        label="End Hour"
                        v-model="time_limits_1"
                        :items="day_hours"
                    ></v-select>
                </div><!--form-group-->
            </div>

            <div class="row" :style="rowStyle" v-if="limits_status">
                <div class="form-inline col-md-2">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="grey lighten-1" class="tooltip-small">
                                    mdi-information-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Enter the distance limit and select measuring unit.</span>
                    </v-tooltip>
                    <i class="fas fa-ruler-horizontal"></i> <span style="padding-left: 5px;"> Distance Limit</span>
                </div>
                <div class="form-group col-md-1 pt-6">
                    <v-switch
                        v-model="distance_limits_status"
                        inset
                    ></v-switch>
                </div><!--form-group-->
                <div class="form-group col-md-2" v-if="distance_limits_status">
                    <v-text-field
                        label="Distance from POI"
                        v-model="distance_limit"
                    ></v-text-field>
                </div><!--form-group-->
                <div class="form-group col-md-2" v-if="distance_limits_status">
                    <v-select
                        label="Unit"
                        v-model="distance_unit"
                        :items="distance_units"
                        @change="unitChanged()"
                    ></v-select>
                </div><!--form-group-->
            </div>
        </div>
    </div>
</template>

<script>
import analyses from "../../../../mixin/analyses";

export default {
    name: "Limits",
    mixins: [analyses],
    props: [
        'dataSetOrder',
        'rowStyle',
        'analysisType'
    ],
    data: () => ({
        day_hours: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        distance_units: ['miles', 'meters'],
        meters_in_one_mile: 1609.344
    }),
    methods: {
        unitChanged() {
            let distance_value = 0;

            if (this.$store.getters['CreateAudienceStore/getLimitsDistanceUnit'](this.dataSetOrder) === 'meters') {
                distance_value = this.$store.getters['CreateAudienceStore/getLimitsDistance'](this.dataSetOrder) * this.meters_in_one_mile

            } else if (this.$store.getters['CreateAudienceStore/getLimitsDistanceUnit'](this.dataSetOrder) === 'miles') {
                distance_value = this.$store.getters['CreateAudienceStore/getLimitsDistance'](this.dataSetOrder) / this.meters_in_one_mile

            }

            this.$store.commit('CreateAudienceStore/SET_LIMITS_DISTANCE', {
                dataset: this.dataSetOrder,
                value: distance_value.toFixed(3)
            })
        },
    },
    created() {
        //
    },
    mounted() {
        //
    },
    computed: {
        limits_status: {
            get() {
                return this.$store.getters['CreateAudienceStore/getLimitsStatus'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_LIMITS_STATUS', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        time_limits_status: {
            get() {
                return this.$store.getters['CreateAudienceStore/getLimitsTimeStatus'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_LIMITS_TIME_STATUS', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        time_limits_0: {
            get() {
                return this.$store.getters['CreateAudienceStore/getLimitsTime'](this.dataSetOrder)[0]
            },
            set(value) {
                let limit_data = [value, this.$store.getters['CreateAudienceStore/getLimitsTime'](this.dataSetOrder)[1]]

                this.$store.commit('CreateAudienceStore/SET_LIMITS_TIME', {
                    dataset: this.dataSetOrder,
                    value: limit_data
                })
            }
        },
        time_limits_1: {
            get() {
                return this.$store.getters['CreateAudienceStore/getLimitsTime'](this.dataSetOrder)[1]
            },
            set(value) {
                let limit_data = [this.$store.getters['CreateAudienceStore/getLimitsTime'](this.dataSetOrder)[0], value]

                this.$store.commit('CreateAudienceStore/SET_LIMITS_TIME', {
                    dataset: this.dataSetOrder,
                    value: limit_data
                })
            }
        },
        distance_limits_status: {
            get() {
                return this.$store.getters['CreateAudienceStore/getLimitsDistanceStatus'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_LIMITS_DISTANCE_STATUS', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        distance_limit: {
            get() {
                return this.$store.getters['CreateAudienceStore/getLimitsDistance'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_LIMITS_DISTANCE', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        distance_unit: {
            get() {
                return this.$store.getters['CreateAudienceStore/getLimitsDistanceUnit'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_LIMITS_DISTANCE_UNIT', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        }
    },
    watch: {
        //
    }
}
</script>

<style scoped>

</style>